import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { NotificationBadge } from '@xingternal/badge';

import styles from './IconWithBadge.css';

const IconWithBadge = ({ icon: Icon, title, count, className }) => {
  const badgeType =
    count < 10
      ? styles.notificationS
      : count > 99
      ? styles.notificationL
      : styles.notificationM;

  return (
    <div className={styles.iconWrapper}>
      <Icon className={cx(className, styles.icon, {})} aria-label={title} />
      {count ? (
        <NotificationBadge className={badgeType}>{count}</NotificationBadge>
      ) : null}
    </div>
  );
};

IconWithBadge.defaultProps = {
  count: 0,
};

IconWithBadge.displaName = 'IconWithBadge';

IconWithBadge.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element]).isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
  count: PropTypes.number,
};

export { IconWithBadge };
